<template>
  <v-dialog
    v-model="internalValue"
    v-bind="$attrs"
    :persistent="persistent"
    max-width="700px"
    max-height="500px"
  >
    <v-card class="pa-5">
      <v-card-title  class="pa-0 mb-3" style="display: flex; align-items: center; justify-content: space-between;">
          <slot name="title">
            <span style="font-weight: bold; font-size: 24px;">
              <slot></slot>
            </span>
          </slot>

        <slot name="close"></slot>
      </v-card-title>
      

      <v-card-text class="pa-0">
        <slot name="content">

        </slot>
      </v-card-text>

      <v-card-actions v-if="$slots.actions" class="pa-0 mt-3">
        <v-spacer></v-spacer>
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: Boolean,
    persistent: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    dialogheight() {
      return this.height;
    }
  },
  methods: {
    openDialog() {
    },
    closeDialog() {
      this.internalValue = false;
    },
    defaultAction() {
      this.closeDialog();
    }
  }
}
</script>

<style lang="scss" scoped></style>
